import handlebars from 'handlebars';

const eq = (a: any, b: any) => a === b;

// Register the 'eq' helper with Handlebars
handlebars.registerHelper('eq', eq)


const valuationTemplate = `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
  <!-- print table -->
  <table id="print-pdf-table">
    <h2 class="pdf-table-heading">{{#if (eq internationalInd 'Y')}}Valuation History{{else}}Valuation History{{/if}}</h2>
    <tr>
      {{#if (eq internationalInd 'Y')}}
      <th>Valuation Date</th>
      <th>Valuation ($)</th>
      <th>Capital Expenditure ($)</th>
      <th>Net Initial Yield Valuation (%)</th>
      <th>[Nominal/True] Equivalent Yield (%)</th>
      <th>Terminal Cap Rate (%)</th>
      <th>Discount Rate (%)</th>
      <th>Growth Rate (%)</th>
      <th>Assumed Hold Period (Years)</th>
      <th>Rent Passing ($)</th>
      <th>Rent Value ($)</th>
      {{else}}
      <th>Appraisal Date</th>
      <th>Appraisal Amt ($)</th>
      {{#if (eq propertyType 'Residential')}}
      <th>PrUnit Amt ($)</th>
      {{else}}
        {{#if (eq propertyType 'Commertial')}}
        <th>PrSqFt Amt ($)</th>
        {{else}}
        <th>PrSqFt Amt ($)</th>
        <th>PrUnit Amt ($)</th>
        {{/if}}
      {{/if}}
      <th>Implied Cap Rate (%)</th>
      <th>Exit Cap Rate (%)</th>
      <th>Discount Rate (%)</th>
      {{/if}}
    </tr>

    {{#each valuationData}}
    <tr>
      {{#if (eq ../internationalInd 'Y')}}
      <td>{{this.valuationDate}}</td>
      <td>{{this.valuation}}</td>
      <td>{{this.capitalExpenditure}}</td>
      <td>{{this.netInitialYieldValuation}}</td>
      <td>{{this.nominalEquivalentYield}}</td>
      <td>{{this.terminalCapRate}}</td>
      <td>{{this.discountRate}}</td>
      <td>{{this.growthRate}}</td>
      <td>{{this.assumedHoldPeriod}}</td>
      <td>{{this.rentPassing}}</td>
      <td>{{this.rentValue}}</td>
      {{else}}
      <td>{{this.appraisaL_DATE}}</td>
      <td>{{this.appraisaL_AMOUNT}}</td>
      {{#if (eq ../propertyType 'Residential')}}
      <td>{{this.peR_UNIT_APPRAISAL_AMT}}</td>
      {{else}}
        {{#if (eq ../propertyType 'Commertial')}}
        <td>{{this.peR_SQFT_APPRAISAL_AMT}}</td>
        {{else}}
        <td>{{this.peR_SQFT_APPRAISAL_AMT}}</td>
        <td>{{this.peR_UNIT_APPRAISAL_AMT}}</td>
        {{/if}}
      {{/if}}
      <td>{{this.implieD_CAP_RATE}}</td>
      <td>{{this.exiT_CAP_RATE}}</td>
      <td>{{this.discounT_RATE}}</td>
      {{/if}}
    </tr>
    {{/each}}
    
    <tr>
    </tr>
  </table>
  <br>
  {{#if valuationComment}}
  <table id="comment-table">
      <tbody>
        <tr>
          <th>Comments</th>
        </tr>
        <tr>
          <td>
            {{{valuationComment.commentText}}}
          </td>
        </tr>
      </tbody>
    </table>
  {{/if}}
</body>
</html>


`;

export default valuationTemplate;
